import React, { useState } from 'react';
import arrow_up from './arrow_up.svg';
import arrow_down from './arrow_down.svg';


const Accordion = ({ title, children }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div class="title_txt">{title}</div>
        <div class='icon'>{isActive ? <img src={arrow_up} alt="Expandir"/> : <img src={arrow_down} alt="Contraer"/> }</div>
      </div>
      {isActive ? <div className="accordion-content" style={{display: "block"}}>{children}</div> : <div className="accordion-content" style={{display: "none"}}>{children}</div>}
    </div>
  );
};

export default Accordion;
